import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const planner = {
  namespaced: true,
  state: {
    user: '',
    driverPlanner: ''
  },
  getters,
  mutations,
  actions
}
